<template>
    <div class="vh-100">

        <main class="content-wrapper flex-100 vh-100">
            <div class="flex-1 p-x-20 p-y-20 w-limit d-flex flex-column justify-content-center">

                <!-- ILLUSTRATION -->
                <div class="f-center m-d-20">
                    <img src="../../assets/img/logo-smartowner-new.svg">
                </div>

                <div class="f-c-midgrey text-center">
                    Selamat datang di SmartOwner. <br>
                    Atur, kelola & pantau usaha laundry Anda kapanpun dan dimanapun dengan mudah.
                </div>

<!--                &lt;!&ndash; TITLE &ndash;&gt;-->
<!--                <div class="f-16 f-semi text-center">-->
<!--                    Hai Smart Owner-->
<!--                </div>-->

<!--                &lt;!&ndash; CAROUSEL &ndash;&gt;-->
<!--                <div class="splide-wrapper m-t-8 pagination-mod">-->
<!--                    <div id="splide-wel" class="splide no-arrows">-->
<!--                        <div class="splide__track">-->
<!--                            <div class="splide__list f-16 f-c-midgrey text-center">-->
<!--                                <div class="splide__slide">-->
<!--                                    Selamat datang di smartlink owner. Atur,kelola &-->
<!--                                    pantau usaha laundry Anda kapanpun dan dimanapun-->
<!--                                </div>-->
<!--                                <div class="splide__slide">-->
<!--                                    Segala kegiatan usaha laundry Anda otomatis tercatat-->
<!--                                    dan terhubung dengan berbagai produk smartlink lainnya.-->
<!--                                </div>-->
<!--                                <div class="splide__slide">-->
<!--                                    Punya berapapun cabang outlet, cukup pantau dari 1-->
<!--                                    aplikasi-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

            </div>

            <!-- BUTTON CONTAINER -->
            <div class="p-y-20 p-x-20 w-limit" id="main-btn">
                <button type="button" class="btn smart-primary m-d-12" @click="goregist"> Daftar</button>
                <button type="button" class="btn smart-secondary" @click="gologin"> Login</button>
            </div>

            <div class="p-x-20 p-y-12 w-limit d-flex flex-column justify-content-center bg-grey fixed-bottom" id="installation-section" v-if="!isPWA">
                <p class="m-d-12 f-c-midgrey text-center f-12">
                    SmartOwner hadir dalam versi aplikasi untuk pengalaman yang lebih baik. Install sekarang!
                </p>
                <button type="button" class="btn smart-black m-d-12" v-if="userAgent === 'ios'" data-toggle="modal" data-target="#modal">
                    <img src="../../assets/img/bx_bxl-apple.png" class="m-r-8" alt="" style="margin-top: -4px"> Install Aplikasi
                </button>
                <a href="https://play.google.com/store/apps/details?id=id.smartlink.bos" target="_blank"
                   type="button" class="btn smart-black m-d-12" v-else>
                    <img src="../../assets/img/mdi_apple.png" alt="" class="m-r-8" style="margin-top: -4px"> Download di Play Store
                </a>
            </div>

            <div class="modal fade" id="modal" role="dialog">
                <div class="modal-dialog modal-lg bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <h5 class="navbar-title text-center">Install aplikasi Smart Owner di iOS</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <ol style="padding-inline-start: 20px">
                                <li class="m-d-12">Tekan tombol <img src="../../assets/img/add-to-home-screen-ios.png" style="margin-top: -8px" alt=""> dibawah</li>
                                <li class="m-d-12">Pilih <img src="../../assets/img/add-app-apple.png" style="margin-top: -8px" alt=""> ‘Tambahkan ke Layar Utama’ atau ‘Add to Home Screen’</li>
                                <li class="m-d-12">Aplikasi Smart Owner akan terinstal dan anda bisa membukanya dari Home Screen.</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: 'Startscreen',
        data() {
            return {
                isPWA: false,
                userAgent: "",
            }
        },
        mounted() {
            $('.utama').fadeIn(300);
            // if ("telp" in localStorage) {
            //     if ("token" in localStorage) {
            //         this.$router.push('/dashboard')
            //     }
            // }
            // this.carousel();
            this.isPWAInstalled()
        },

        methods: {
            carousel() {
                var option = {
                    // type: 'loop',
                    rewind: true,
                    // autoplay: true,
                    // interval: 7000,
                    gap: '12px',
                };

                new Splide('#splide-wel', option).mount();
            },
            gologin() {
                this.$router.push('/login')
            },
            goregist() {
                this.$router.push('/register')
            },
            isPWAInstalled() {
		        if (window.matchMedia('(display-mode: standalone)').matches) {
                this.isPWA = true
		        } else {
			          this.isPWA = false
                this.getUserAgent()
                this.installationSection()
		        }
	        },
	        getUserAgent() {
		        var iosDevice = !!navigator.userAgent.match(/iPhone|iPod|iPad/i)
                var androidDevice = !!navigator.userAgent.match(/Android/i)
		        if (iosDevice) {
                    this.userAgent = "ios"
                } else if (androidDevice) {
		            this.userAgent = "android"
		        } else {
			        this.userAgent = ""
		        }
	        },
          installationSection() {
              if ($("#installation-section").is(":visible")) {
                $("#main-btn").css({"margin-bottom": $("#installation-section").height() + 40 + "px"})

                if ($(window).scrollTop() + $(window).height() < $(document).height()) {
                  $("#installation-section").addClass("box-installation-section")
                  $(window).scroll(function() {
                    if($(window).scrollTop() + $(window).height() == $(document).height()) {
                      $("#installation-section").removeClass("box-installation-section")
                    } else {
                      $("#installation-section").addClass("box-installation-section")
                    }
                  });
                }
              }
          }
        }
    }
</script>

<style scoped>
    .modal-dialog {
        width: 100vw;
        margin: 0 auto;
        position: fixed;
    }

    .box-installation-section {
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
      transition: ease-in-out 400ms;
    }
</style>